import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {App} from './app/App';
import reportWebVitals from './utils/reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import AuthGate from "./utils/AuthGate";


const cognitoAuthConfig = {
    authority: process.env.REACT_APP_COGNITO_AUTHORITY,
    client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    redirect_uri: window.location.origin,
    post_logout_redirect_uri: `${window.location.origin}/login`,
    response_type: "code",
    scope: "openid",
};

const onSignInCallback = () => {
    const url = new URL(window.location.href);
    window.history.replaceState({}, document.title, url.pathname + url.hash);
    window.location.reload()
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <AuthProvider {...cognitoAuthConfig} onSigninCallback={onSignInCallback}>
            <AuthGate>
                <App />
            </AuthGate>
        </AuthProvider>
    </React.StrictMode>
);

reportWebVitals();
